
unit f_datipersonali;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery,
  w_edit, w_label, DB, un_user;

type
  TVisibilita = (
    visDateErrate,
    visNessunRecord,
    visLimiteRecord,
    visCiSonoRecord,
    visCaricamentoInCorso
  );

const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo gli ultimi 300 prodotti';
  msgDateErrate = 'Correggi le date corrette per visualizzare gli prodotti';
  msgNessunRecord = 'Nessun record da visualizzare';
  msgCaricamentoInCorso = 'Caricamento record in corso...';

type
  { TFrmDatiPersonali }

  TFrmDatiPersonali = class(TWidget)
    procedure AfterRender; override;

  private
    whereDate: String;
    dt1str, dt2str: String;

    procedure ShowDatiPersonali; async;
    procedure SalvaDati; async;

    procedure QryDatiPersonaliOnFilterRecord(
      DataSet: TDataSet;
      var Accept: Boolean
    );

    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita: TVisibilita);

  published
    procedure filtro_change;
    procedure filtro_input;
    procedure lblHeader_click; async;
    procedure salva_click(Event: TJSEvent); async;
    procedure annulla_click(Event: TJSEvent); async;

    filtro: TWEdit;
    QryDatiPersonali: TQuery;
    labelTop: TWLabel;
    labelBottom: TWLabel;

    idanagrafica: TJSHTMLInputElement;
    dsragionesociale: TJSHTMLInputElement;
    dsindirizzo: TJSHTMLInputElement;
    dscap: TJSHTMLInputElement;
    dslocalita: TJSHTMLInputElement;
    dsprovincia: TJSHTMLInputElement;
    dstelefono: TJSHTMLInputElement;
    dsemail: TJSHTMLInputElement;
    dtdatanascita: TJSHTMLInputElement;
    dtscadenzapatente: TJSHTMLInputElement;

    fldisplunedimat: TJSHTMLInputElement;
    fldisplunedipom: TJSHTMLInputElement;
    fldispmartedimat: TJSHTMLInputElement;
    fldispmartedipom: TJSHTMLInputElement;
    fldispmercoledimat: TJSHTMLInputElement;
    fldispmercoledipom: TJSHTMLInputElement;
    fldispgiovedimat: TJSHTMLInputElement;
    fldispgiovedipom: TJSHTMLInputElement;
    fldispvenerdimat: TJSHTMLInputElement;
    fldispvenerdipom: TJSHTMLInputElement;
    fldispsabatomat: TJSHTMLInputElement;
    fldispsabatopom: TJSHTMLInputElement;
    fldispdomenicamat: TJSHTMLInputElement;
    fldispdomenicapom: TJSHTMLInputElement;
  end;

implementation

{$R *.html}

{ TFrmDatiPersonali }

procedure TFrmDatiPersonali.AfterRender;
begin
  ShowDatiPersonali;
end;


procedure TFrmDatiPersonali.ShowDatiPersonali; async;

var
  IdUtenteLoggato: string;

  function DataHTML(const NomeCampo: string): string;
  begin
    if QryDatiPersonali.FieldByName(NomeCampo).IsNull then
      Result := ''
    else
      Result := FormatDateTime(
        'yyyy"-"mm"-"dd"',
        QryDatiPersonali.FieldByName(NomeCampo).AsDateTime
      );
  end;

  function CampoMarcato(const NomeCampo: string): Boolean;
  var
    Valore: string;
  begin
    Result := False;

    if QryDatiPersonali.IsEmpty then
      Exit;

    if QryDatiPersonali.FieldByName(NomeCampo).IsNull then
      Exit;

    Valore := Trim(
      QryDatiPersonali.FieldByName(NomeCampo).AsString
    );

    Result :=
      SameText(Valore, 'X') or
      SameText(Valore, '1') or
      SameText(Valore, 'true') or
      SameText(Valore, 't') or
      SameText(Valore, 's') or
      SameText(Valore, 'si') or
      SameText(Valore, 'y');
  end;

begin
  ImpostaVisibilita(visCaricamentoInCorso);

  IdUtenteLoggato :=
    user.QryUtenti.FieldByName('idanagrafica').AsString;

  QryDatiPersonali.Close;

  QryDatiPersonali.SQL.Text :=
    'select * from an_anagrafiche ' +
    'where idsocieta = ''DON001'' ' +
    'and idanagrafica = ' + QuotedStr(IdUtenteLoggato);

  await(QryDatiPersonali.Open);

  RefreshFiltro;

  if QryDatiPersonali.IsEmpty then
    Exit;

  // Dati anagrafici
  idanagrafica.value :=
    QryDatiPersonali.FieldByName('idanagrafica').AsString;

  dsragionesociale.value :=
    QryDatiPersonali.FieldByName('dsragionesociale').AsString;

  dsindirizzo.value :=
    QryDatiPersonali.FieldByName('dsindirizzo').AsString;

  dscap.value :=
    QryDatiPersonali.FieldByName('dscap').AsString;

  dslocalita.value :=
    QryDatiPersonali.FieldByName('dslocalita').AsString;

  dsprovincia.value :=
    QryDatiPersonali.FieldByName('dsprovincia').AsString;

  dstelefono.value :=
    QryDatiPersonali.FieldByName('dstelefono').AsString;

  dsemail.value :=
    QryDatiPersonali.FieldByName('dsemail').AsString;

  // Date per input HTML type="date"
  dtdatanascita.value :=
    DataHTML('dtdatanascita');

  dtscadenzapatente.value :=
    DataHTML('dtscadenzapatente');

  // Disponibilità settimanale
  fldisplunedimat.checked :=
    CampoMarcato('fldisplunedimat');

  fldisplunedipom.checked :=
    CampoMarcato('fldisplunedipom');

  fldispmartedimat.checked :=
    CampoMarcato('fldispmartedimat');

  fldispmartedipom.checked :=
    CampoMarcato('fldispmartedipom');

  fldispmercoledimat.checked :=
    CampoMarcato('fldispmercoledimat');

  fldispmercoledipom.checked :=
    CampoMarcato('fldispmercoledipom');

  fldispgiovedimat.checked :=
    CampoMarcato('fldispgiovedimat');

  fldispgiovedipom.checked :=
    CampoMarcato('fldispgiovedipom');

  fldispvenerdimat.checked :=
    CampoMarcato('fldispvenerdimat');

  fldispvenerdipom.checked :=
    CampoMarcato('fldispvenerdipom');

  fldispsabatomat.checked :=
    CampoMarcato('fldispsabatomat');

  fldispsabatopom.checked :=
    CampoMarcato('fldispsabatopom');

  fldispdomenicamat.checked :=
    CampoMarcato('fldispdomenicamat');

  fldispdomenicapom.checked :=
    CampoMarcato('fldispdomenicapom');
end;

procedure TFrmDatiPersonali.SalvaDati;
begin
  //
end;

procedure TFrmDatiPersonali.QryDatiPersonaliOnFilterRecord(
  DataSet: TDataSet;
  var Accept: Boolean
);
var
  str: String;
  i: Integer;
begin
  Accept := True;
  str := filtro.value.ToLowerInvariant;

  if str = '' then
    Exit;

  for i := 0 to DataSet.FieldCount - 1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
      Exit;
  end;

  Accept := False;
end;


procedure TFrmDatiPersonali.RefreshFiltro;
begin
  //QryDatiPersonali.Filtered := filtro.value.Trim <> '';
  //QryDatiPersonali.First;
  //tab1.RenderDataSet(QryDatiPersonali);
  //
  //if QryDatiPersonali.IsEmpty then
  //  ImpostaVisibilita(visNessunRecord)
  //else if QryComunicazioni.RecordCount >= limiteRecord then
  //  ImpostaVisibilita(visLimiteRecord)
  //else
  //  ImpostaVisibilita(visCiSonoRecord);
end;


procedure TFrmDatiPersonali.SetLabel(lbl: TWLabel; value: String);
begin
  lbl.Visible := value <> '';
  lbl.labelbody.innerHTML := value;
end;


procedure TFrmDatiPersonali.ImpostaVisibilita(visibilita: TVisibilita);
begin
  //SetLabel(labelTop, '');
  //SetLabel(labelBottom, '');
  //
  //case visibilita of
  //  visDateErrate: SetLabel(labelTop, msgDateErrate);
  //  visNessunRecord: SetLabel(labelBottom, msgNessunRecord);
  //  visLimiteRecord: SetLabel(labelBottom, msgLimiteRecord);
  //  visCaricamentoInCorso: SetLabel(labelBottom, msgCaricamentoInCorso);
  //end;
  //
  //filtro.Visible := visibilita <> visDateErrate;
  //pnltab1.Visible := visibilita in [visLimiteRecord, visCiSonoRecord];
end;

procedure TFrmDatiPersonali.salva_click(Event: TJSEvent);
var
  SQL: String;
  DataNascitaSQL: String;
  ScadenzaPatenteSQL: String;
  LunMatSQL: String;
  LunPomSQL: String;
  MarMatSQL: String;
  MarPomSQL: String;
  MerMatSQL: String;
  MerPomSQL: String;
  GioMatSQL: String;
  GioPomSQL: String;
  VenMatSQL: String;
  VenPomSQL: String;
  SabMatSQL: String;
  SabPomSQL: String;
  DomMatSQL: String;
  DomPomSQL: String;
begin

  // 1. Preparazione delle variabili prima dell'UPDATE
  if fldisplunedimat.Checked then
    LunMatSQL := QuotedStr('X')
  else
    LunMatSQL := 'NULL';

  if fldisplunedipom.Checked then
    LunPomSQL := QuotedStr('X')
  else
    LunPomSQL := 'NULL';

  if fldispmartedimat.Checked then
    MarMatSQL := QuotedStr('X')
  else
    MarMatSQL := 'NULL';

  if fldispmartedipom.Checked then
      MarPomSQL := QuotedStr('X')
  else
      MarPomSQL := 'NULL';

  if fldispmercoledimat.Checked then
    MerMatSQL := QuotedStr('X')
  else
    MerMatSQL := 'NULL';

  if fldispmercoledipom.Checked then
    MerPomSQL := QuotedStr('X')
  else
    MerPomSQL := 'NULL';

  if fldispgiovedimat.Checked then
    GioMatSQL := QuotedStr('X')
  else
    GioMatSQL := 'NULL';

  if fldispgiovedipom.Checked then
    GioPomSQL := QuotedStr('X')
  else
    GioPomSQL := 'NULL';

  if fldispvenerdimat.Checked then
    VenMatSQL := QuotedStr('X')
  else
    VenMatSQL := 'NULL';

  if fldispvenerdipom.Checked then
    VenPomSQL := QuotedStr('X')
  else
    VenPomSQL := 'NULL';

  if fldispsabatomat.Checked then
    SabMatSQL := QuotedStr('X')
  else
    SabMatSQL := 'NULL';

  if fldispsabatopom.Checked then
    SabPomSQL := QuotedStr('X')
  else
    SabPomSQL := 'NULL';

  if fldispdomenicamat.Checked then
    domMatSQL := QuotedStr('X')
  else
    DomMatSQL := 'NULL';

  if fldispdomenicapom.Checked then
    DomPomSQL := QuotedStr('X')
  else
    DomPomSQL := 'NULL';

  // 2. Preparazione data di nascita
  if Trim(dtdatanascita.value) = '' then
    DataNascitaSQL := 'NULL'
  else
    DataNascitaSQL :=
      'DATE ' + QuotedStr(Copy(dtdatanascita.value, 1, 10));

  // 3. Preparazione scadenza patente
  if Trim(dtscadenzapatente.value) = '' then
    ScadenzaPatenteSQL := 'NULL'
  else
    ScadenzaPatenteSQL :=
      'DATE ' + QuotedStr(Copy(dtscadenzapatente.value, 1, 10));

  try
    // 4. Costruzione UPDATE
    SQL :=
        'UPDATE AN_ANAGRAFICHE SET '
      + 'DSINDIRIZZO = ' + QuotedStr(dsindirizzo.value) + ', '
      + 'DSCAP = ' + QuotedStr(dscap.value) + ', '
      + 'DSLOCALITA = ' + QuotedStr(dslocalita.value) + ', '
      + 'DSPROVINCIA = ' + QuotedStr(dsprovincia.value) + ', '
      + 'DTDATANASCITA = ' + DataNascitaSQL + ', '
      + 'DTSCADENZAPATENTE = ' + ScadenzaPatenteSQL + ', '
      + 'DSTELEFONO = ' + QuotedStr(dstelefono.value) + ', '
      + 'DSEMAIL = ' + QuotedStr(dsemail.value) + ', '

      // Disponibilità lunedì
      + 'FLDISPLUNEDIMAT = ' + LunMatSQL + ', '
      + 'FLDISPLUNEDIPOM = ' + LunPomSQL + ', '
      // Disponibilità martedì
      + 'FLDISPMARTEDIMAT = ' + MarMatSQL + ', '
      + 'FLDISPMARTEDIPOM = ' + MarPomSQL + ', '
      // Disponibilità mercoledì
      + 'FLDISPMERCOLEDIMAT = ' + MerMatSQL + ', '
      + 'FLDISPMERCOLEDIPOM = ' + MerPomSQL + ', '
      // Disponibilità mercoledì
      + 'FLDISPGIOVEDIMAT = ' + GioMatSQL + ', '
      + 'FLDISPGIOVEDIPOM = ' + GioPomSQL + ', '
      // Disponibilità venerdì
      + 'FLDISPVENERDIMAT = ' + VenMatSQL + ', '
      + 'FLDISPVENERDIPOM = ' + VenPomSQL + ', '
      // Disponibilità sabato
      + 'FLDISPSABATOMAT = ' + SabMatSQL + ', '
      + 'FLDISPSABATOPOM = ' + SabPomSQL + ', '
      // Disponibilità domenica
      + 'FLDISPDOMENICAMAT = ' + DomMatSQL + ', '
      + 'FLDISPDOMENICAPOM = ' + DomPomSQL

      + ' WHERE IDANAGRAFICA = ' + IntToStr(StrToInt(idanagrafica.value));

    // 5. Esecuzione UPDATE
    QryDatiPersonali.SQL.Text := SQL;

    await(QryDatiPersonali.ExecuteSql);

    // 6. Conferma
    ShowMessage('Anagrafica aggiornata con successo.');

    Close();

  except
    on E: Exception do
    begin
      ShowMessage(
        'Errore durante il salvataggio:' +
        #13#10 +
        E.Message
      );
    end;
  end;
end;

procedure TFrmDatiPersonali.annulla_click(Event: TJSEvent);
begin
  Close();
end;

procedure TFrmDatiPersonali.filtro_change;
begin
  RefreshFiltro;
end;


procedure TFrmDatiPersonali.filtro_input;
begin
  RefreshFiltro;
end;


procedure TFrmDatiPersonali.lblHeader_click; async;
begin
  await(ShowDatiPersonali);
end;


initialization
  RegisterWeb(TFrmDatiPersonali);

end.

